const ACTIONS = {
    SET_ENDERECO: 'SET_ENDERECO',
    SET_CEP: 'SET_CEP',
    SET_NUMERO: 'SET_NUMERO',
    SET_COMPLEMENTO: 'SET_COMPLEMENTO',
    CLEAR_ENDERECO: 'CLEAR_ENDERECO'
};
const INITIAL_STATE = {
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    localidade: '',
    uf: '',
    ibge: ''
};
export function EnderecoReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.SET_ENDERECO:
            return {
                ...state,
                cep: action.endereco.cep,
                logradouro: action.endereco.logradouro,
                bairro: action.endereco.bairro,
                localidade: action.endereco.localidade,
                uf: action.endereco.uf,
                ibge: action.endereco.ibge
            };
        case ACTIONS.SET_CEP:
            return {
                ...state,
                cep: action.cep
            };
        case ACTIONS.SET_NUMERO:
            return {
                ...state,
                numero: action.numero
            };
        case ACTIONS.SET_COMPLEMENTO:
            return {
                ...state,
                complemento: action.complemento
            };
        case ACTIONS.CLEAR_ENDERECO:
            return {
                ...state,
                cep: '',
                logradouro: '',
                bairro: '',
                localidade: '',
                uf: '',
                ibge: '',
                numero: '',
                complemento: ''
            };
        default:
            return state;
    }
}
